import { WizardStatus, WizardResponse } from '../types/wizard';

const wizardService = {
  async getWizardStatus(): Promise<WizardStatus> {
    console.log('🔍 WIZARD SERVICE: Checking status...');
    try {
      const apiUrl = import.meta.env.VITE_API_URL || 'https://quantifaid-backend-757948789112.us-central1.run.app';
      const token = localStorage.getItem('token');
      
      if (!token) {
        console.error('❌ WIZARD SERVICE: No token found!');
        return { seen: true }; // Default to seen if no token
      }

      console.log('📡 WIZARD SERVICE: Making API call to:', `${apiUrl}/auth/wizard/status`);
      
      const response = await fetch(`${apiUrl}/auth/wizard/status`, {
        method: 'GET',
        headers: {
          Authorization: `Bearer ${token}`
        }
      });

      if (!response.ok) {
        console.error(`❌ WIZARD SERVICE: API error ${response.status}:`, response.statusText);
        const text = await response.text();
        console.error('Response:', text);
        throw new Error(`Failed to fetch wizard status: ${response.status} ${response.statusText}`);
      }

      const data = await response.json();
      console.log('✅ WIZARD SERVICE: Got response:', data);
      return data;
    } catch (error) {
      console.error('❌ WIZARD SERVICE: Error:', error);
      return { seen: true }; // Default to seen on error
    }
  },

  async completeWizard(): Promise<WizardResponse> {
    console.log('🔍 WIZARD SERVICE: Marking as complete...');
    try {
      const apiUrl = import.meta.env.VITE_API_URL || 'https://quantifaid-backend-757948789112.us-central1.run.app';
      const token = localStorage.getItem('token');
      
      if (!token) {
        console.error('❌ WIZARD SERVICE: No token found!');
        throw new Error('No authentication token found');
      }

      console.log('📡 WIZARD SERVICE: Making API call...');
      
      const response = await fetch(`${apiUrl}/auth/wizard/complete`, {
        method: 'POST',
        headers: {
          Authorization: `Bearer ${token}`
        }
      });

      if (!response.ok) {
        console.error(`❌ WIZARD SERVICE: API error ${response.status}:`, response.statusText);
        const text = await response.text();
        console.error('Response:', text);
        throw new Error(`Failed to complete wizard: ${response.status} ${response.statusText}`);
      }

      const data = await response.json();
      console.log('✅ WIZARD SERVICE: Marked as complete:', data);
      return data;
    } catch (error) {
      console.error('❌ WIZARD SERVICE: Error:', error);
      throw error;
    }
  }
};

export default wizardService; 